import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Database02 = function Database02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 5c0 1.6569-4.0294 3-9 3S3 6.6569 3 5m18 0c0-1.6568-4.0294-3-9-3S3 3.3432 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 4.7202c0 1.66-4 3-9 3s-9-1.34-9-3M21 14.44c0 1.66-4 3-9 3s-9-1.34-9-3"
    })
  }));
};
export default Database02;